<script>
  import { getContext } from "svelte"
  import { SELECTED_COLOR_KEY } from "./ChromaPicker.svelte"

  const selectedColor = getContext(SELECTED_COLOR_KEY)

  const handleHexChange = e => {
    if (e.target.value) {
      selectedColor.change({ hex: $selectedColor.hex }, $selectedColor)
    }
  }

  const handleOpacityChange = e => {
    if (e.target.value) {
      selectedColor.change({ opacity: $selectedColor.opacity }, $selectedColor)
    }
  }

  const handleRgbChange = e => {
    if (e.target.value) {
      selectedColor.change(
        { rgb: `rgb(${$selectedColor.r}, ${$selectedColor.g}, ${$selectedColor.b})` },
        $selectedColor
      )
    }
  }
</script>

<div class="hex">
  <div class="mr-4">
    <label for="hex-code" id="code-label">Hex</label>
    <input
      type="text"
      name="hex-code"
      id="hex-code"
      bind:value={$selectedColor.hex}
      on:input={e => handleHexChange(e)}
    />
  </div>

  <div>
    <label for="opacity" id="opacity-label">Opacity</label>
    <input
      type="number"
      name="A"
      id="opacity"
      bind:value={$selectedColor.opacity}
      on:input={e => handleOpacityChange(e)}
      min={0}
      max={100}
    />
  </div>
</div>

<div class="rgb mt-2">
  <div class="mr-3">
    <label for="R" id="R-label">R</label>
    <input
      type="number"
      name="R"
      id="R"
      bind:value={$selectedColor.r}
      on:input={e => handleRgbChange(e)}
      min={0}
      max={255}
    />
  </div>

  <div class="mr-3">
    <label for="G" id="G-label">G</label>
    <input
      type="number"
      name="G"
      id="G"
      bind:value={$selectedColor.g}
      on:input={e => handleRgbChange(e)}
      min={0}
      max={255}
    />
  </div>

  <div>
    <label for="B" id="B-label">B</label>
    <input
      type="number"
      name="B"
      id="B"
      bind:value={$selectedColor.b}
      on:input={e => handleRgbChange(e)}
      min={0}
      max={255}
    />
  </div>
</div>
